const setCursor = (data) => {
    const {
        enabled,
        inputId,
        caretPos,
        requestId,
    } = data

    if (enabled) {
        console.log(requestId);
        return setTimeout(() => {
            const inputElement = document.querySelector(`#${inputId} input`);

            inputElement.setSelectionRange(caretPos, caretPos);

            inputElement.focus()
        }, 300)
    }
}

class CursorPlacer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        console.log('CursorPlacer')
    }

    get placeCursor() {
        return this.getAttribute('placecursor');
    }

    set placeCursor(value) {
        this.setAttribute('placecursor', value);
    }

    static get observedAttributes() {
        return ['placecursor'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
        const newSettingsRecieved = JSON.parse(newVal)

        setCursor(newSettingsRecieved)
    }
}
customElements.define('cursor-placer', CursorPlacer);